<app-third-party-login-header></app-third-party-login-header>
<app-loading></app-loading>
<app-toast></app-toast>
<ng-container>
    <app-route-page>
        <div class="d-flex mt-md-5 align-items-center flex-md-row flex-column psic-gap-9">
            <img
                class="col-md-6 col-12"
                [src]="'../../../../assets/images/Customer-service-login-landing.svg'"
                [alt]="'login-image'"
            />
            <div class="d-flex col-md-6 col-12 flex-column form-container">
                <h2>Customer Support Center</h2>
                <form [formGroup]="form" class="d-flex flex-column psic-gap-4">
                    <lib-input-text [field]="policyNumberField" formControlName="policyNumber"></lib-input-text>
                    <p class="caption">To verify your account, fill in at least 2 fields below.</p>
                    <lib-input-text [field]="loanNumberField" formControlName="loanNumber"></lib-input-text>
                    <lib-input-text [field]="zipCodeField" formControlName="zipCode"></lib-input-text>
                    <div class="d-flex flex-row psic-gap-4">
                        <lib-input-radio
                            [radioLeft]="radioLeft"
                            [field]="insuredTypeField"
                            formControlName="insuredType"
                            class="radio-inline"
                        >
                        </lib-input-radio>
                    </div>

                    @if (insuredType === 'insured') {
                    <div class="d-flex flex-row psic-gap-4">
                        <div class="flex-fill">
                            <lib-input-text [field]="firstNameField" formControlName="firstName"></lib-input-text>
                        </div>
                        <div class="flex-fill">
                            <lib-input-text [field]="lastNameField" formControlName="lastName"></lib-input-text>
                        </div>
                    </div>
                    } @if (insuredType === 'trust') {
                    <lib-input-text [field]="trustNameField" formControlName="trustName"></lib-input-text>
                    }

                    <re-captcha [size]="'normal'" (resolved)="onCaptchaResponse($event)"></re-captcha>

                    <lib-button
                        (callback)="onSubmit()"
                        buttonText="Submit"
                        [disabled]="!form.valid || !recaptchaValid || isLoading"
                    ></lib-button>
                </form>
                @if(failedAttempts >=1){
                <p class="caption psic-mt-4">
                    Having trouble finding the policy?
                    <lib-button
                        [buttonText]="'Contact us'"
                        [buttonType]="'borderless'"
                        (callback)="onContactUs()"
                    ></lib-button>
                </p>
                }
            </div>
        </div>
    </app-route-page>
</ng-container>
<!-- Contact Us Modal -->
@if (showContactModal) {
<div
    class="contact-modal-backdrop dg_mg-70-background d-flex align-items-center justify-content-center"
    (click)="closeContactModal()"
></div>
} @if (showContactModal) {
<div class="contact-modal">
    <div class="d-flex flex-column align-items-center psic-mb-6 psic-gap-2">
        <mat-icon [svgIcon]="'info-circle'" class="modal-help-icon mat-icon-64 p1-50-color"></mat-icon>
        <h5>Can’t find your policy?</h5>
        <p class="caption psic-mb-4">Provide details about the issue below so we can assist you.</p>
    </div>
    <form [formGroup]="contactForm" class="d-flex flex-column psic-gap-4">
        <lib-input-text [field]="contactEmailField" formControlName="contactEmail"></lib-input-text>
        <lib-input-text [field]="contactPhoneField" formControlName="contactPhone"></lib-input-text>
        <lib-input-text [field]="contactDescriptionField" formControlName="contactDescription"></lib-input-text>
        <div class="d-flex flex-row align-items-center justify-content-center psic-gap-10">
            <div
                class="d-flex flex-row align-items-center psic-gap-1 caption pointerCursor"
                (click)="oncancelContact()"
            >
                <mat-icon [svgIcon]="'back'" class="back-icon p1-50-color"></mat-icon>
                <lib-button buttonText="cancel" [buttonType]="'borderless'"></lib-button>
            </div>
            <lib-button (callback)="onContactSubmit()" buttonText="Submit" [disabled]="!contactForm.valid"></lib-button>
        </div>
    </form>
</div>
}
